export default __webpack_public_path__ + "fa6ffda3f32ae17872e2f5dbc1332b96.svg";